import { createApi } from '@reduxjs/toolkit/query/react';
import { Application } from 'client-experience-toolbox';
import { axiosBaseQuery } from '../utils/rtk-query';

interface GetApplicationsByEmailParams {
  email: string;
  fullApplication?: boolean;
}

export const digitalOnboardingServiceApi = createApi({
  reducerPath: 'digitalOnboardingServiceApi',
  baseQuery: axiosBaseQuery({ baseUrl: config.digitalOnboardingServiceUrl }),
  tagTypes: ['Applications'],
  endpoints: (builder) => ({
    getApplicationsByEmail: builder.query<Application[], GetApplicationsByEmailParams>({
      query: ({ email, fullApplication }) => ({
        url: `/application/underwriting?email=${encodeURIComponent(email)}${
          fullApplication ? '&fullApplication=true' : ''
        }`,
        method: 'GET',
      }),
      providesTags: ['Applications'],
    }),
  }),
});

export const { useGetApplicationsByEmailQuery } = digitalOnboardingServiceApi;
